module.exports = __webpack_public_path__ + "static/img/day5.eb0e486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/day5.jpg
// module id = yCSs
// module chunks = 0